// extracted by mini-css-extract-plugin
export var filterIncDec = "_47-0";
export var leftBorder = "_47-1";
export var rightBorder = "_47-2";
export var stringInput = "_47-3";